module.exports = __webpack_public_path__ + "static/media/TouchBaseHelp.c2916f43.PNG";